export default "__VITE_ASSET__B3P1MVMu__"